import Icon from '@/components/ui/AppIcon';
import AppImage from '@/components/ui/AppImage';

interface Testimonial {
  name: string;
  position: string;
  company: string;
  image: string;
  alt: string;
  quote: string;
  service: string;
  rating: number;
}

interface TestimonialSectionProps {
  testimonials: Testimonial[];
}

export default function TestimonialSection({
  testimonials,
}: TestimonialSectionProps) {
  return (
    <div className="bg-surface rounded-lg p-6 mb-8">
      <h2 className="text-xl font-headline font-bold text-primary mb-6">
        Client Success Stories
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {testimonials.map((testimonial, index) => (
          <div
            key={index}
            className="bg-card rounded-lg p-6 shadow-subtle border border-border"
          >
            <div className="flex items-start space-x-4 mb-4">
              <div className="relative w-12 h-12 rounded-full overflow-hidden flex-shrink-0">
                <AppImage
                  src={testimonial.image}
                  alt={testimonial.alt}
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="flex-1">
                <h4 className="text-sm font-headline font-bold text-primary">
                  {testimonial.name}
                </h4>
                <p className="text-xs font-body text-textSecondary">
                  {testimonial.position}
                </p>
                <p className="text-xs font-body text-textSecondary">
                  {testimonial.company}
                </p>
              </div>
              <div className="flex items-center space-x-1">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Icon
                    key={i}
                    name="StarIcon"
                    size={14}
                    variant="solid"
                    className="text-accent"
                  />
                ))}
              </div>
            </div>

            <p className="text-sm font-body text-textPrimary mb-3 italic">
              &quot;{testimonial.quote}&quot;
            </p>

            <div className="flex items-center space-x-2 pt-3 border-t border-border">
              <Icon name="WrenchScrewdriverIcon" size={14} className="text-secondary" />
              <span className="text-xs font-body text-textSecondary">
                Service: {testimonial.service}
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}